<template>
  <v-card v-if="summary && summary.total" dark flat class="cw-profile-card">
    <v-card-text class="cw-profile-card-content"><div><h2>Deine neuen Verträge</h2><p>{{ summary.total }} {{ summary.total === 1 ? 'Vertrag' : 'Verträge' }}<template v-if="summary.openInvoices"> · Offene Rechnung vorhanden</template></p></div><v-btn dark outlined to="/contract/my-v2">Verträge und Rechnungen<v-icon right aria-hidden="true">mdi-arrow-right</v-icon></v-btn></v-card-text>
  </v-card>
</template>

<script>
import api from "@/api/contractWorkspacePublicApi"
export default {
  name: "ContractProfileCard",
  data: () => ({ summary: null }),
  async created() { try { this.summary = await api.summary() } catch (_) { /* The existing profile remains available when V2 has not been enabled. */ } },
}
</script>

<style scoped lang="scss">
.cw-profile-card { margin: 0 1rem 1rem; border: 1px solid #36453c; background: #1c2420; border-radius: .75rem; }
.cw-profile-card-content { display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: 1rem; color: #e4ede6; }
.cw-profile-card h2 { font-size: 1rem; line-height: 1.5; margin: 0; font-weight: 500; }
.cw-profile-card p { font-size: .875rem; color: #adbdb2; margin: .25rem 0 0; }
.cw-profile-card .v-btn { font-size: .875rem; letter-spacing: normal; white-space: normal; min-height: 2.75rem; height: auto; padding: .75rem; }
</style>
